"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = DigitalAudiences;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _urlSearchParams = _interopRequireDefault(require("@ungap/url-search-params"));

var _semanticUiReact = require("semantic-ui-react");

var _Sidebar = _interopRequireDefault(require("../components/CampaignCreator/Sidebar"));

var _SegmentList = _interopRequireDefault(require("../components/SegmentList"));

var _DigitalAudiencesTable = _interopRequireDefault(require("../components/CampaignCreator/DigitalAudiences/DigitalAudiencesTable"));

var _actions = require("../actions");

var _campaignCreator = require("../actions/campaignCreator");

var _useFeatureAccessHook = require("../helpers/useFeatureAccessHook");

var _index = require("../../index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function DigitalAudiences(props) {
  var fixedAudienceView = props.fixedAudienceView;
  var dispatch = (0, _reactRedux.useDispatch)();
  var digitalAudiencesPermission = (0, _reactRedux.useSelector)(function (state) {
    return state.options.permissions.workflowPermission;
  });
  var campaignCreatorAccess = (0, _useFeatureAccessHook.useFeatureAccess)(digitalAudiencesPermission);
  var audienceView = (0, _reactRedux.useSelector)(function (state) {
    return state.audienceView.view;
  });
  var isDataPage = (0, _reactRedux.useSelector)(function (state) {
    return state.options.isDataPage.value;
  }); // Set selected persona state to that passed through from deliver campaign

  var searchParams = new _urlSearchParams["default"](props.location.search);
  var quadrantPersonaIds = searchParams.get('personaIds') || false;
  (0, _react.useEffect)(function () {
    if (quadrantPersonaIds) {
      var quadPersonas = quadrantPersonaIds.split(',').map(function (id) {
        return {
          id: Number(id)
        };
      });
      dispatch((0, _actions.setSelectedPersonas)(quadPersonas));
      dispatch((0, _campaignCreator.loadDigitalAudiencesVendors)(fixedAudienceView));
    }
  }, [dispatch, quadrantPersonaIds, fixedAudienceView]);
  (0, _react.useEffect)(function () {
    dispatch((0, _actions.loadSuperSegments)());
    dispatch((0, _index.featureAccess)());
    return function () {
      if (isDataPage) {
        dispatch((0, _actions.resetDataPage)());
      }
    };
  }, [dispatch, isDataPage]);
  var superSegments = (0, _reactRedux.useSelector)(function (state) {
    return state.superSegments.bySlug;
  });
  var digitalAudiencesRecords = (0, _reactRedux.useSelector)(function (state) {
    return state.campaignCreator.digitalAudiencesVendors.vendors;
  });

  if (!campaignCreatorAccess) {
    return '';
  }

  if (!superSegments) {
    return /*#__PURE__*/_react["default"].createElement(_index.LoadingIndicator, null);
  }

  var handleCheckBoxAction = function handleCheckBoxAction() {
    dispatch((0, _campaignCreator.loadDigitalAudiencesVendors)(fixedAudienceView));
  };

  var Title = function Title() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
      className: "grouped-personas__icon",
      name: "bars",
      size: "large"
    }), /*#__PURE__*/_react["default"].createElement("h2", {
      className: "digital-audiences__sub-title"
    }, "Select ", fixedAudienceView || audienceView.textPlural));
  };

  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "campaign-creator-page"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "grouped-personas__row"
  }, /*#__PURE__*/_react["default"].createElement(_Sidebar["default"], {
    open: true,
    title: /*#__PURE__*/_react["default"].createElement(Title, null),
    body: /*#__PURE__*/_react["default"].createElement("div", {
      className: "scroll-box"
    }, /*#__PURE__*/_react["default"].createElement(_SegmentList["default"], {
      expanded: true,
      fixedAudienceView: fixedAudienceView,
      handleCheckBoxAction: handleCheckBoxAction
    }))
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "grouped-personas__table"
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "audience-profiling__title",
    "data-testid": "digital-audiences"
  }, "Media"), /*#__PURE__*/_react["default"].createElement(_DigitalAudiencesTable["default"], {
    digitalAudiencesRecords: digitalAudiencesRecords
  })))));
}